module.exports = __webpack_public_path__ + "static/media/gal-2.14dc6f65.jpeg";